import { ListItemText } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { DatePicker } from '@mui/x-date-pickers';
import { isNotNullOrUndefined, vyDate } from '@vy/utils';
import type { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { useRenewContract } from '../../../../../hooks/requests/use-renew-contract';
import { useDialog } from '../../../../../hooks/use-dialog';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';
import { runMutation } from '../../../../../utils/vy-mutation';

type MenuItemContractRenewalProps = {
  contractId: string;
  contractEndDate: Date;
  isTerminated: boolean;
};

export const MenuItemContractRenewal: React.FC<MenuItemContractRenewalProps> = ({
  contractId,
  contractEndDate,
  isTerminated,
}) => {
  const navigate = useVyNavigate();
  const { handleClose, handleOpen, isDialogOpen } = useDialog();
  const renewContractMutation = useRenewContract(contractId);

  const defaultContractStartDate = vyDate(contractEndDate).add(1, 'day').startOf('day');
  const [contractStartDate, setContractStartDate] = useState<Dayjs>(defaultContractStartDate);

  const handleDialogSubmit = async () => {
    await runMutation(
      renewContractMutation,
      { startDate: vyDate(contractStartDate).toDate() },
      {
        pending: 'Saving...',
        success: 'Saved',
        error: 'Failed to renew contract',
      },
      {
        onSuccess: ({ contractId: createdContractId }: { contractId: string }) => {
          navigate(`/plans/contracts/${createdContractId}`);
        },
      },
    );
  };

  return (
    <>
      <div>
        <MenuItem disabled={isTerminated} onClick={handleOpen}>
          <ListItemText>Renew Contract</ListItemText>
        </MenuItem>

        <VyDialog
          open={isDialogOpen}
          onClose={handleClose}
          label="You're about to renew the contract"
          labelDescription="Choose a start date"
          ctaText="Confirm"
          ctaDisabled={renewContractMutation.isLoading}
          cancelButtonText="Cancel"
          onSubmit={handleDialogSubmit}
        >
          <div className="mt-5 flex flex-col">
            <DatePicker
              label="Start date"
              defaultValue={contractStartDate}
              onChange={(newDate) => {
                if (isNotNullOrUndefined(newDate)) {
                  setContractStartDate(vyDate(newDate));
                }
              }}
              className="grow"
            />
          </div>
        </VyDialog>
      </div>
    </>
  );
};
